import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { RefreshCw } from "lucide-react";

const LABELS = { ca_daily: "CA Journalier", achats: "Achats Hebdo", mix_fournisseur: "Mix Fournisseur", wasaplan: "Wasaplan", qualite: "Qualité", rh: "RH", pl: "Compte de Résultat", productivite: "Productivité", productivite_target: "Productivité Target", base_info: "Base Info", inventaire: "Inventaires" };
const fmt = (iso) => new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

/* Bandeau « Dernière mise à jour » basé sur le dernier import réussi du Centre des imports */
export function LastImportInfo({ kinds = [], className = "" }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/kpi/last-import", { params: kinds.length ? { kinds: kinds.join(",") } : {} }).then(r => setD(r.data)).catch(() => setD({})); }, [kinds.join(",")]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const l = d.latest;
  const details = Object.values(d.by_kind || {}).filter(i => i.kind !== l?.kind).map(i => `${LABELS[i.kind] || i.kind} : ${fmt(i.created_at)}`).join(" · ");
  return (
    <div data-testid="last-import-info" className={`inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-[11px] text-slate-600 ${className}`} title={details || undefined}>
      <RefreshCw className="w-3.5 h-3.5 text-emerald-600 shrink-0"/>
      {l ? <span>Dernière mise à jour : <b className="text-slate-900">{fmt(l.created_at)}</b> · {LABELS[l.kind] || l.kind}{l.filename ? ` · ${l.filename}` : ""}{l.user_name ? ` · par ${l.user_name}` : ""}</span>
         : <span>Aucun import enregistré pour cette page (Administration › Centre des imports)</span>}
    </div>
  );
}
